/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Warm_Falcon_GazeInputs */

const en_bold_warm_falcon_gaze = /** @type {(inputs: Bold_Warm_Falcon_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Report`)
};

const de_bold_warm_falcon_gaze = /** @type {(inputs: Bold_Warm_Falcon_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht erstellen`)
};

/**
* | output |
* | --- |
* | "Create Report" |
*
* @param {Bold_Warm_Falcon_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_warm_falcon_gaze = /** @type {((inputs?: Bold_Warm_Falcon_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Warm_Falcon_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_warm_falcon_gaze(inputs)
	return de_bold_warm_falcon_gaze(inputs)
});